export default "__VITE_ASSET__C$o$esbH__"